import { Generator } from "@visactor/vrender-core/common/generator";

import { application } from "@visactor/vrender-core/application";

import { BaseWindowHandlerContribution, WindowHandlerContribution } from "@visactor/vrender-core";

import { LynxCanvas } from "../../canvas/contributions/lynx";

class MiniAppEventManager {
    constructor() {
        this.cache = {};
    }
    addEventListener(type, func) {
        type && func && (this.cache[type] = this.cache[type] || {
            listener: []
        }, this.cache[type].listener.push(func));
    }
    removeEventListener(type, func) {
        if (!type || !func) return;
        if (!this.cache[type]) return;
        const index = this.cache[type].listener.findIndex((f => f === func));
        index >= 0 && this.cache[type].listener.splice(index, 1);
    }
    cleanEvent() {
        this.cache = {};
    }
}

function setMiniAppEventTarget(event, key, value) {
    if (event && value) try {
        event[key] = value;
    } catch (_a) {
        Object.defineProperty(event, key, {
            configurable: !0,
            value: value
        });
    }
}

function isValidCoordinate(value) {
    return "number" == typeof value && Number.isFinite(value);
}

function pickCoordinate(...values) {
    for (let i = 0; i < values.length; i++) if (isValidCoordinate(values[i])) return values[i];
}

function setLynxEventValue(event, key, value) {
    try {
        event[key] = value;
    } catch (_a) {
        Object.defineProperty(event, key, {
            configurable: !0,
            value: value
        });
    }
}

function normalizeLynxTouchEventPoint(event) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    const touch = null !== (_b = null === (_a = null == event ? void 0 : event.changedTouches) || void 0 === _a ? void 0 : _a[0]) && void 0 !== _b ? _b : null === (_c = null == event ? void 0 : event.touches) || void 0 === _c ? void 0 : _c[0];
    if (!touch) return;
    const x = pickCoordinate(event.x, event.offsetX, event.clientX, event.pageX, touch.x, touch.offsetX, touch.clientX, touch.pageX), y = pickCoordinate(event.y, event.offsetY, event.clientY, event.pageY, touch.y, touch.offsetY, touch.clientY, touch.pageY);
    null != x && null != y && (!event.touches && event.changedTouches && setLynxEventValue(event, "touches", "touchend" === event.type || "touchcancel" === event.type ? [] : event.changedTouches), 
    setLynxEventValue(event, "x", x), setLynxEventValue(event, "y", y), setLynxEventValue(event, "offsetX", null !== (_d = event.offsetX) && void 0 !== _d ? _d : x), 
    setLynxEventValue(event, "offsetY", null !== (_e = event.offsetY) && void 0 !== _e ? _e : y), 
    setLynxEventValue(event, "clientX", null !== (_f = event.clientX) && void 0 !== _f ? _f : x), 
    setLynxEventValue(event, "clientY", null !== (_g = event.clientY) && void 0 !== _g ? _g : y), 
    setLynxEventValue(event, "pageX", null !== (_h = event.pageX) && void 0 !== _h ? _h : x), 
    setLynxEventValue(event, "pageY", null !== (_j = event.pageY) && void 0 !== _j ? _j : y), 
    touch.x = null !== (_k = touch.x) && void 0 !== _k ? _k : x, touch.y = null !== (_l = touch.y) && void 0 !== _l ? _l : y, 
    touch.offsetX = null !== (_m = touch.offsetX) && void 0 !== _m ? _m : x, touch.offsetY = null !== (_o = touch.offsetY) && void 0 !== _o ? _o : y, 
    touch.clientX = null !== (_p = touch.clientX) && void 0 !== _p ? _p : x, touch.clientY = null !== (_q = touch.clientY) && void 0 !== _q ? _q : y, 
    touch.pageX = null !== (_r = touch.pageX) && void 0 !== _r ? _r : x, touch.pageY = null !== (_s = touch.pageY) && void 0 !== _s ? _s : y);
}

export class LynxWindowHandlerContribution extends BaseWindowHandlerContribution {
    get container() {
        return null;
    }
    constructor(global = application.global) {
        super(), this.global = global, this.type = "lynx", this.eventManager = new MiniAppEventManager;
    }
    getTitle() {
        return this.canvas.id && this.canvas.id.toString();
    }
    getWH() {
        return {
            width: this.canvas.width / (this.canvas.dpr || 1),
            height: this.canvas.height / (this.canvas.dpr || 1)
        };
    }
    getXY() {
        return {
            x: 0,
            y: 0
        };
    }
    createWindow(params) {
        params.canvas ? this.createWindowByCanvas(params) : this.createWindowByConfig(params);
    }
    createWindowByConfig(params) {
        const nativeCanvas = this.global.createCanvas({
            width: params.width,
            height: params.height
        }), options = {
            width: params.width,
            height: params.height,
            dpr: params.dpr,
            nativeCanvas: nativeCanvas,
            id: Generator.GenAutoIncrementId().toString(),
            canvasControled: !1
        };
        this.canvas = new LynxCanvas(options);
    }
    createWindowByCanvas(params) {
        let canvas;
        if ("string" == typeof params.canvas) {
            if (canvas = this.global.getElementById(params.canvas), canvas || (canvas = this.global.createCanvas({
                id: params.canvas,
                width: params.width,
                height: params.height,
                dpr: params.dpr
            })), !canvas) throw new Error("canvasId 参数不正确，请确认canvas存在并插入dom");
        } else canvas = params.canvas;
        let width = params.width, height = params.height;
        if (null == width || null == height || !params.canvasControled) {
            const data = canvas.getBoundingClientRect();
            width = data.width, height = data.height;
        }
        let dpr = params.dpr;
        null == dpr && (dpr = canvas.width / width), this.canvas = new LynxCanvas({
            width: width,
            height: height,
            dpr: dpr,
            nativeCanvas: canvas,
            canvasControled: params.canvasControled
        });
    }
    releaseWindow() {}
    resizeWindow(width, height) {
        this.canvas.resize(width, height);
    }
    setDpr(dpr) {
        this.canvas.dpr = dpr;
    }
    getContext() {
        return this.canvas.getContext();
    }
    getNativeHandler() {
        return this.canvas;
    }
    getDpr() {
        return this.canvas.dpr;
    }
    addEventListener(type, listener) {
        this.eventManager.addEventListener(type, listener);
    }
    removeEventListener(type, listener) {
        this.eventManager.removeEventListener(type, listener);
    }
    dispatchEvent(event) {
        var _a;
        const {type: type} = event;
        if (!this.eventManager.cache[type]) return !1;
        const nativeCanvas = null === (_a = this.canvas) || void 0 === _a ? void 0 : _a.nativeCanvas;
        return setMiniAppEventTarget(event, "target", nativeCanvas), setMiniAppEventTarget(event, "currentTarget", nativeCanvas), 
        normalizeLynxTouchEventPoint(event), event.preventDefault = () => {}, event.stopPropagation = () => {}, 
        this.eventManager.cache[type].listener && this.eventManager.cache[type].listener.forEach((f => {
            f(event);
        })), !0;
    }
    getStyle() {
        return {};
    }
    setStyle(style) {}
    getBoundingClientRect() {
        const wh = this.getWH();
        return {
            x: 0,
            y: 0,
            width: wh.width,
            height: wh.height,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
    }
    clearViewBox(color) {
        const vb = this.viewBox, context = this.getContext(), dpr = this.getDpr();
        context.nativeContext.save(), context.nativeContext.setTransform(dpr, 0, 0, dpr, 0, 0), 
        context.clearRect(vb.x1, vb.y1, vb.x2 - vb.x1, vb.y2 - vb.y1), color && (context.fillStyle = color, 
        context.fillRect(vb.x1, vb.y1, vb.x2 - vb.x1, vb.y2 - vb.y1)), context.nativeContext.restore();
    }
}

LynxWindowHandlerContribution.env = "lynx";

export function bindLynxWindowContribution(container) {
    var _a, _b;
    (null === (_a = container.isBound) || void 0 === _a ? void 0 : _a.call(container, LynxWindowHandlerContribution)) || container.bind(LynxWindowHandlerContribution).toSelf(), 
    (null === (_b = container.getNamed) || void 0 === _b ? void 0 : _b.call(container, WindowHandlerContribution, LynxWindowHandlerContribution.env)) || container.bind(WindowHandlerContribution).toService(LynxWindowHandlerContribution).whenTargetNamed(LynxWindowHandlerContribution.env);
}
//# sourceMappingURL=lynx-contribution.js.map
